var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-filtered-select',{attrs:{"selected-key":_vm.selectedProvider ? _vm.selectedProvider.value : null,"options":_vm.activeProviderOptions,"invalid":_vm.invalid,"placeholder":"Provider"},on:{"updateDropdownValue":_vm.onUpdateValue,"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }